/**
 * Copilot bar panel visibility preference (localStorage + merge helper).
 * User dismissed the CopilotBar while a scenario is active (option A — default open until dismissed).
 */
export const COPILOT_BAR_HIDDEN_STORAGE_KEY = 'CopilotBarHidden';

/**
 * @param {Object} copilotBarState - Scenario-built bar props (typically includes isOpen from buildConfig).
 * @returns {Object} Same shape with isOpen merged against {@link COPILOT_BAR_HIDDEN_STORAGE_KEY}.
 */
export function mergeCopilotBarOpenWithUserPreference(copilotBarState) {
    if (typeof window === 'undefined') {
        return copilotBarState;
    }
    const userHidBar = window.localStorage.getItem(COPILOT_BAR_HIDDEN_STORAGE_KEY) !== null;
    return {
        ...copilotBarState,
        isOpen: Boolean(copilotBarState.isOpen) && !userHidBar,
    };
}
